import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';

@Pipe({
  name: 'trustUrl',
  pure: true
})
export class TrustUrlPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {
  }

  transform(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

}
